import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../../common/Api";
import { PendingOrgEditStore } from "./PendingOrgEditStore";

export class PendingOrgsStore {
  loading = false;
  orgEdit: PendingOrgEditStore;

  filter: any = {
    page: 0,
    size: 2000,
    period: [undefined, undefined],
  };
  data = {
    total: 0,
    items: [],
  };
  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }
  constructor() {
    makeAutoObservable(this, {});
    this.orgEdit = new PendingOrgEditStore(this);

  }

  @action
  refresh() {
    this.loading = true;
    const { page, size } = this.filter;
    const filter: any = {
      pending: true,
      page,
      size,
    };
    Api.org
      .orgs(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.orgs;
        });
      })
      .finally(() => (this.loading = false));
  }
}

export const pendingOrgs = new PendingOrgsStore();
